/**
 * Modal.js
 * Created by Suresh Mittapelli on 6/19/2020.
 * Updated existing component with Motif
 */
import React from 'react';
import styled from 'styled-components';
import Label from '../BaseComponentWrappers/MotifLabel';
import FormField from '../BaseComponentWrappers/MotifFormField';
import Typeahead from '../BaseComponentWrappers/MotifTypeahead';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {alertIcErrorOutline24px} from '@ey/motif-react-wrapper/assets/icons/index';

function TextInputNew({
	label,
	inputVal,
	id,
	errormessage,
	showinputerror,
	optionaltext,
	onInputChange,
	onKeyDownHander,
	onBlurHandler,
	onFocusHandler,
	wrapperClass,
	disabled,
	placeholder,
	maxLength,
	onSelect,
	typeAhead,
	items,
	onClose,
	onClear,
	onEnter,
	onOpen,
	hideClearButton,
	clearButtonTitle,
	onFocusShow,
	ref,
	...props
}) {
	return (
		<StyledInputWrapper
			className={`
                ${typeAhead ? wrapperClass : wrapperClass + ' noTypeAhead'}
                ${showinputerror ? 'input-invalid' : ''}
            `}
		>
			<FormField
				children={
					<>
						<Label
							for={id}
							children={
								<>
									{label}
									<span> {optionaltext && optionaltext}</span>
								</>
							}
						/>
						<StyledMotifTypeahead
							required={showinputerror}
							value={inputVal || ''}
							id={id}
							onChange={onInputChange}
							maxlength={maxLength}
							disabled={disabled}
							placeholder={placeholder}
							optionaltext={optionaltext}
							onKeyDown={onKeyDownHander}
							onBlur={onBlurHandler}
							onFocus={onFocusHandler}
							ref={ref}
							onSelect={onSelect}
							items={items}
							onClose={onClose}
							onClear={onClear}
							onEnter={onEnter}
							onOpen={onOpen}
							hideClearButton={hideClearButton}
							clearButtonTitle={clearButtonTitle}
							onFocusShow={onFocusShow}
							className="motifTypeaheadInput motif-input"
							{...props}
						/>
						{showinputerror && (
							<StyledHelpBlock className="StyledHelpBlock">
								{/* <SVGICONS name="error" styleName="small" /> */}
								<MotifIcon src={alertIcErrorOutline24px} styleName="medium" />
								<span className="error-text">{errormessage}</span>
							</StyledHelpBlock>
						)}
					</>
				}
			/>
		</StyledInputWrapper>
	);
}

export default TextInputNew;

const StyledInputWrapper = styled.section`
	.motif-form-field {
		margin-bottom: var(--px-16);
		.motif-label-for-text {
			top: var(--px-14);
			font-size: var(--px-14);
			left: var(--px-10);
			padding-left: 0;
		}
		&.motif-form-field-has-value,
		&.motif-form-field-focused {
			.motif-label-for-text {
				top: var(--px-4);
				font-size: var(--px-12);
				span {
					font-size: var(--px-10);
				}
			}
		}
	}
	&.inputDisabled {
		label.motif-label.motif-label-for-text {
			color: var(--neutrals-700);
		}
		.motif-input-component {
			border-color: var(--neutrals-300);
			background: var(--neutrals-100);
			color: var(--neutrals-300);
			.motif-input-0 {
				cursor: default;
				color: var(--neutrals-700);
			}
		}
	}
	&.floating-label {
		.motif-label-for-text {
			top: var(--px-4);
			font-size: var(--px-12);
			span {
				font-size: var(--px-10);
			}
		}
	}
	&.noTypeAhead {
		.motif-select {
			&.motif-select-open {
				display: none;
			}
		}
	}
`;
const StyledHelpBlock = styled.section`
	color: var(--neutrals-900);
	margin-top: var(--px-5);
	font-weight: 300 !important;
	font-size: var(--px-12);
	position: relative;
	display: flex;
	align-items: center;
	.error-text {
		display: inline-flex;
		align-items: center;
		line-height: var(--px-18);
		color: var(--red-600);
	}
	.motif-icon {
		display: inline-flex;
		align-items: center;
		svg {
			width: var(--px-18) !important;
			height: var(--px-18) !important;
			fill: var(--red-600);
			margin: 0 var(--px-5) 0 0;
			path {
				fill: var(--red-600);
			}
		}
	}
`;

const StyledMotifTypeahead = styled(Typeahead)`
	&.motif-input-component {
		border: var(--px-1) solid var(--neutrals-300);
		.motif-input {
			background: transparent;
			color: var(--neutrals-900);
			padding: var(--px-20) var(--px-5) var(--px-8) var(--px-10);
			font-size: var(--px-13);
			font-family: 'EYInterstate' !important;
			width: calc(100% - var(--px-26));
			border-width: 0 !important;
			&:hover:not(:disabled),
			&:focus:not(:disabled) {
				background: transparent;
				border-width: 0 !important;
				margin-bottom: 0;
			}
		}
		.motif-typeahead-close-button {
			top: var(--px-14);
		}
	}
`;
